import { api } from 'components/api'
import { surveyPath } from 'components/routes/api'
import type { PersistedQuestion } from 'components/surveys/questionTypes'

interface ApiSurveyResponse {
  survey_slug: string
  name: string
  description: string | null
  questions: PersistedQuestion[]
}

export interface SurveyData {
  surveySlug: string
  name: string
  description: string | null
  questions: PersistedQuestion[]
}

const toSurveyData = (response: ApiSurveyResponse): SurveyData => ({
  surveySlug: response.survey_slug,
  name: response.name,
  description: response.description,
  questions: response.questions
})

export const fetchSurvey = async (surveyId: string): Promise<SurveyData> => {
  const response = await api.get<unknown, ApiSurveyResponse>({
    url: surveyPath(surveyId),
    headers: { Accept: 'application/json' },
    cacheOptions: { enabled: false }
  })

  return toSurveyData(response.data)
}
